// components/subscription/CouponForm.jsx
import React, { useState } from 'react';
import { useSubscription } from '../../contexts/SubscriptionContext';

const CouponForm = ({ planId, onApply }) => {
  const [couponCode, setCouponCode] = useState('');
  const { applyCoupon, couponData, loading, error, clearError } = useSubscription();

  const handleSubmit = async (e) => {
    e.preventDefault();
    clearError();
    if (!couponCode.trim()) return;
    
    try {
      const data = await applyCoupon(couponCode, planId);
      onApply(data);
    } catch (err) {
      // Error is handled in the context
    }
  };

  return (
    <div className="mt-4">
      <form onSubmit={handleSubmit} className="flex space-x-2">
        <input
          type="text"
          value={couponCode}
          onChange={(e) => setCouponCode(e.target.value)}
          placeholder="Enter coupon code"
          className="flex-1 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          disabled={loading}
        />
        <button
          type="submit"
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
          disabled={loading || !couponCode.trim()}
        >
          {loading ? 'Applying...' : 'Apply'}
        </button>
      </form>
      
      {error && <div className="mt-2 text-sm text-red-600">{error}</div>}
      
      {(couponData && couponData) && (
        <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-md">
          <div className="font-medium text-green-800">
            Coupon applied: {couponData.name}
          </div>
          <div className="text-sm text-green-700">
            {couponData.discount_percentage}% discount
          </div>
        </div>
      )}
    </div>
  );
};

export default CouponForm;